import { render } from "./LayoutTopbar.vue?vue&type=template&id=80857334"
import script from "./LayoutTopbar.vue?vue&type=script&lang=js"
export * from "./LayoutTopbar.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__